/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadPccPatientDetailsResponse } from './UploadPccPatientDetailsResponse';
import {
    UploadPccPatientDetailsResponseFromJSON,
    UploadPccPatientDetailsResponseFromJSONTyped,
    UploadPccPatientDetailsResponseToJSON,
    UploadPccPatientDetailsResponseToJSONTyped,
} from './UploadPccPatientDetailsResponse';

/**
 * 
 * @export
 * @interface UploadPccPatientDetails200Response
 */
export interface UploadPccPatientDetails200Response {
    /**
     * 
     */
    data?: UploadPccPatientDetailsResponse;
}

/**
 * Check if a given object implements the UploadPccPatientDetails200Response interface.
 */
export function instanceOfUploadPccPatientDetails200Response(value: object): value is UploadPccPatientDetails200Response {
    return true;
}

export function UploadPccPatientDetails200ResponseFromJSON(json: any): UploadPccPatientDetails200Response {
    return UploadPccPatientDetails200ResponseFromJSONTyped(json, false);
}

export function UploadPccPatientDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadPccPatientDetails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UploadPccPatientDetailsResponseFromJSON(json['data']),
    };
}

export function UploadPccPatientDetails200ResponseToJSON(json: any): UploadPccPatientDetails200Response {
    return UploadPccPatientDetails200ResponseToJSONTyped(json, false);
}

export function UploadPccPatientDetails200ResponseToJSONTyped(value?: UploadPccPatientDetails200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UploadPccPatientDetailsResponseToJSON(value['data']),
    };
}

